import React, { useState,useEffect } from "react";
import {
  Col,
  Form,
  Row,
  Table,
  Image,
  // Modal,
  Container,
  // Button,
} from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import { FormControl, InputLabel, Select, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { settlementSummary,settlementReport } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import { ORDER_STATUS, ORDER_TYPE, PAYMENT_STATUS } from "../../../enums/OrderEnums";
import BasicPagination from "../../Pagination/Pagination";
import moment from "moment";

const roles = [0, 1];

const SettlementScanAndPayReport = (props) => {
  const [showFilter, setshowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  // const [dateQuery, setDateQuery] = useState({
  //   startDate: moment().format("YYYY-MM-DD"),
  //   endDate: moment().format("YYYY-MM-DD"),
  // });
  const [state, setState] = useState({
    search: "",
  });

  let type = props.match.params.type;
  let id = props.match.params.id;
  let restaurant_id = props.match.params.restaurant_id;

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  // const onDateChangeHandler = () => (data, type) => {
  //   setDateQuery(data);
  // }

  const onSearchChange = (e) => {
    
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    
  };

  useEffect((async) => {
    props.settlementSummary(props.auth.user.accessToken);
    props.settlementReport(id,props.auth.user.accessToken,"SCAN");
    // console.log("settlemet",props);
  }, []);

  let tempdata = props?.settlementReports?.data && props?.settlementReports?.data.filter((data) =>{
    return(
      data?.order?.order_id.toLowerCase().includes(state.search.toLowerCase())
    )
 });

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation backButtonLink={`/mainsettlementsvendor`} leftText="vendorReview" displayText="Back" 
            />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                  <div className="f24_700_HelveticaNeue">
                    Settlement Reports
                  </div>
                </div>
                <Row className="align-items-center">
                  <Col className="col-auto seating-topbar-search">
                    <div className="filter-button">
                      <div
                        onClick={() => {
                          setshowFilter(!showFilter);
                        }}
                        className="d-flex align-items-center justify-content-between cursor"
                      >
                        <Image
                          alt="filter"
                          title="filter"
                          width="20px"
                          src={require("../../../assets/images/ActionImages/image/filter.svg")}
                        />
                        <div className="f12-500 text-blue mx-2">Filter</div>
                        <i
                          className="fa fa-angle-down text-blue"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </Col>
                  <Col xs={8} md={4}>
                    <div className="filter-button-search">
                      <Paper component="form" className="enSearch2 d-flex">
                        <IconButton type="submit" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          placeholder="Search"
                          name="search"
                          inputProps={{
                            "aria-label": "Search by Name or Phone Number",
                          }}
                            onChange={onSearchChange}
                            value={state.search}
                        />
                      </Paper>
                    </div>
                  </Col>
                </Row>
                {showFilter && (
                  <div
                    className="container-fluid"
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    <div className=" p-4">
                      <Row>
                        <Col md={6}>
                          Date Range
                          <div
                            className="d-flex justify-content-start"
                            style={{ alignItems: "center" }}
                          >
                            <TextField
                              type="date"
                              variant="outlined"
                              onChange={props.onStartDateChange}
                              value={props.startDate}
                            />
                            &nbsp;To&nbsp;
                            <TextField
                              type="date"
                              variant="outlined"
                              onChange={props.onEndDateChange}
                              value={props.endDate}
                            />
                          </div>
                          <br />
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Select User</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Select User
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => {}}
                                label="Select User"
                                inputProps={{
                                  name: "Select User",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Status</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Status
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => {}}
                                label="Status"
                                inputProps={{
                                  name: "Status",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Order Type</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Order Type
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => {}}
                                label="Order Type"
                                inputProps={{
                                  name: "Order Type",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Select Payment Method</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Select Payment Method
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => {}}
                                label="Select Payment Method"
                                inputProps={{
                                  name: "Select Payment Method",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Transaction Type</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Transaction Type
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => {}}
                                label="Transaction Type"
                                inputProps={{
                                  name: "Transaction Type",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div class="mt-5 d-flex">
                        <button
                          type="button"
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                          title="Cancel Button"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          title="Confirm Button"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="mt-2 mb-2 p-3"
                  style={{ backgroundColor: "#ffffff" }}
                >
              {props?.settlemetData?.map((data,index)=>{
                return(
                  `${data?._id}` === id && `${data?.restaurant_id}` === restaurant_id && `${data?.payout_type}` === type ?
                  <div>
                  <Row className="mt-3">
                    <Col md={2}>
                      <div className="f12-500">Settlement Date</div>
                        <div className="f12-400">{moment(data?.createdAt).format("Do MMM YYYY")}</div>
                        <div className="f12-400">{moment(data?.createdAt).format("hh:mm A")}</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Transaction ID</div>
                      <div className="f12-400">{data?.scan_and_pay_transactional_id[0]?._id}</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Settlement ID</div>
                      <div className="f12-400">{data?._id}</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Payment Gateway</div>
                      <div className="f12-400">{data?.settle_razorpay_payout?.mode}</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Payment Type</div>
                      <div className="f12-400">NEFT</div>
                    </Col>
                    <Col md={2}>
                      <div className="f12-500">Payment Event</div>
                      <div className="f12-400">Outgoing Payment</div>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-2 mb-3">
                      <Col md={2}>
                        <div className="f12-500">Gross Amount</div>
                        <div className="f12-400">Rs. {props?.settlementReports?.stats && props?.settlementReports?.stats[0]?.totalGross ? props?.settlementReports?.stats[0]?.totalGross : "0"}</div>
                      </Col>
                      <Col md={2}>
                        <div className="f12-500">Net Amount</div>
                        <div className="f12-400">Rs. {props?.settlementReports?.stats && props?.settlementReports?.stats[0]?.totalNet ? props?.settlementReports?.stats[0]?.totalNet : "0"}</div>
                      </Col>
                      <Col md={2}>
                        <div className="f12-500">Tip</div>
                        <div className="f12-400">Rs. {props?.settlementReports?.stats && props?.settlementReports?.stats[0]?.totalTip ? props?.settlementReports?.stats[0]?.totalTip : "0"}</div>
                      </Col>
                      <Col md={2}>
                        <div className="f12-500">Taxes</div>
                        <div className="f12-400">Rs. {props?.settlementReports?.stats && props?.settlementReports?.stats[0]?.totalTax ? props?.settlementReports?.stats[0]?.totalTax : "0"}</div>
                      </Col>
                      <Col md={2}>
                        <div className="f12-500">Remittance Status</div>
                        {`${data?.settle_payment_status}` === '0' ? 
                          <div className="f12-400 badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>
                            Pending
                          </div> : null || 
                        `${data?.settle_payment_status}` === '1' ?
                            <div className="f12-400 badge badge-success p-2" style={{borderRadius:'1rem',color:'white'}}>
                              Settled
                            </div> : null ||
                          `${data?.settle_payment_status}` === '2' ?
                          <div className="f12-400 badge badge-danger p-2" style={{borderRadius:'1rem',color:'white'}}>
                            Cancelled
                          </div> : null ||
                          `${data?.settle_payment_status}` === '3' ?
                          <div className="f12-400 badge badge-info p-2" style={{borderRadius:'1rem',color:'white'}}>
                            Failure
                          </div> : null ||
                          `${data?.settle_payment_status}` === '4' ?
                          <div className="f12-400 badge badge-secondary p-2" style={{borderRadius:'1rem',color:'white'}}>
                            Pending
                          </div> : null } 
                      </Col>
                      <Col md={2}>
                        <div className="f12-500">Settlement Period</div>
                        <div className="d-flex">
                          <div className="f12-400">
                          <div className="f12-400">{moment(data?.payoutStartDate).format("Do MMM YYYY")}</div>
                          <div className="f12-400">{moment(data?.payoutStartDate).format("hh:mm A")}</div>
                          </div>
                          <div className="f12-400">To</div>
                          <div className="f12-400">
                          <div className="f12-400">{moment(data?.payoutEndDate).format("Do MMM YYYY")}</div>
                        <div className="f12-400">{moment(data?.payoutEndDate).format("hh:mm A")}</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div> : null
                  )
                })}
                </div>
                <div className="user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        
                        <th style={{ width: "130px" }} className="f12-700">
                        Request Type/<br /> Request ID
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Invoice <br />ID
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Payment <br />Gateway
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Payment Type/<br /> Transaction ID
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Net Amount
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Order Total<br /> Amount
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Tip
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Donation
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Remittance<br /> Status/ID
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                        Merchant <br />Account No.<br /> & IFSC
                        </th>
                        
                        {/* <th style={{ width: "130px" }} className="f12-700">
                          Payment <br />
                          Transaction ID
                        </th>
                        <th style={{ width: "130px" }} className="f12-700">
                          Payment <br />
                          Transaction ID
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {props.auth.secondary_loader ? <SmallLoader/> : !isEmpty(props?.settlementReports?.data) && props?.settlementReports?.data.slice(start,end).map((data, index) => {
                        return (
                          <tr
                            key={index}
                            className="super_admin_all_users_table_body mt-2"
                            style={{ wordBreak: "break-word" }}
                          >
                            <td colSpan="7" className="p-0 w-100">
                              <table className="w-100 HideShowTable enMinWidth900">
                                <tbody>
                                  <tr>
                                    
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">{data?.scan_and_pay_transactional_id[0]?.event_request_id?.occasion}{ORDER_TYPE[data?.scan_and_pay_transactional_id[0]?.orderId?.order_type]}<br />{data?.scan_and_pay_transactional_id[0]?.event_request_id?.event_id}{ORDER_STATUS[data?.scan_and_pay_transactional_id[0]?.orderId?.order_status]}</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">12345678</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">RazorPay</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">{data?.scan_and_pay_transactional_id[0]?.transaction_type} <br />{data?.scan_and_pay_transactional_id[0]?._id}</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ 520</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ 520</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ {data?.scan_and_pay_transactional_id[0]?.orderId?.tip?.amount}</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ {data?.scan_and_pay_transactional_id[0]?.orderId?.donation?.amount}</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                    {`${data?.settle_payment_status}` === '0' ? 
                                           <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>Pending</div> : null || 
                                          `${data?.settle_payment_status}` === '1' ?  <div className="badge badge-success p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[data?.settle_payment_status]}</div> : null ||
                                          `${data?.settle_payment_status}` === '2' ?  <div className="badge badge-danger p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[data?.settle_payment_status]}</div> : null ||
                                          `${data?.settle_payment_status}` === '3' ?  <div className="badge badge-danger p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[data?.settle_payment_status]}</div> : null ||
                                          `${data?.settle_payment_status}` === '4' ?  <div className="badge badge-info p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[data?.settle_payment_status]}</div> : null 
                                        }
                                      <div className="f12-400">
                                        {data?._id}
                                      </div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                    <div className="f12-400">{data?.settlement_account_details?.account_number}<br />{data?.settlement_account_details?.account_ifsc}</div>
                                    </td>
                                    
                                    {/* <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ 520</div>
                                    </td>
                                    <td style={{ width: "130px" }}>
                                      <div className="f12-400">₹ 520</div>
                                    </td> */}
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.settlementReports?.data?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

// const Filter = (props) => {
//   const [open, setOpen] = useState(false);
//   const [state, setState] = useState(0);
//   const onOpenModal = () => setOpen(true);
//   const onCloseModel = () => setOpen(false);
//   return (
//     <>
//       <div
//         onClick={onOpenModal}
//         className="d-flex align-items-center justify-content-between cursor"
//       >
//         <Image
//           alt="filter"
//           title="filter"
//           width="20px"
//           src={require("../../../assets/images/ActionImages/image/filter.svg")}
//         />
//         <div className="f12-500 text-blue mx-2">Filter</div>
//         <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
//       </div>
//       {/* <Modal show={open} onHide={onCloseModel} centered>
//           <Modal.Header className="py-0 pt-2 border-0" closeButton>
//             <Modal.Title>Filter</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="f16-500">
//             Select one relevant option from below
//             <div className="row mt-4">
//               <div className="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 0 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(0);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">All</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 1 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(1);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Active</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 2 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(2);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Inactive</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer className="justify-content-start border-0">
//             <Button
//               variant="outline-secondary"
//               className="btn-md mr-4 px-5"
//               onClick={() => {
//                 setState(0);
//                 props.filterData(1, onCloseModel);
//               }}
//             >
//               Reset Filter
//             </Button>
//             <Button
//               variant="danger"
//               className="btn-md px-5"
//               onClick={() => {
//                 props.filterData(state, onCloseModel);
//               }}
//             >
//               Apply Filter
//             </Button>
//           </Modal.Footer>
//         </Modal> */}
//     </>
//   );
// };


SettlementScanAndPayReport.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  settlemetData: PropTypes.array.isRequired,
  settlementReport: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  settlemetData: state.reports.settlemetReport.data,
  settlementReports: state.reports.settlement_type_report,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  settlementSummary,
  settlementReport,
})(SettlementScanAndPayReport);

// export default SettlementScanAndPayReport;
